import { type FC } from "react";
import { Presentation } from "./Presentation";
import { type UserDeclineReportContent } from "./type";

type Props = {
  userDeclineReportContent: UserDeclineReportContent;
  isBiyo: boolean;
  homeUrl: string;
  jobEntryIndexUrl: string;
};

export const UserDeclineReport: FC<Props> = ({
  userDeclineReportContent,
  isBiyo,
  homeUrl,
  jobEntryIndexUrl,
}) => {
  const isDeclineDetailsNotEmpty = userDeclineReportContent.declineDetails.length !== 0;
  const showDeclineDetailsReadMoreButton = userDeclineReportContent.declineDetails.length >= 3;

  const linkToHome = () => {
    window.location.href = homeUrl;
  };

  const linkToJobEntryIndex = () => {
    window.location.href = jobEntryIndexUrl;
  };

  return (
    <Presentation
      userDeclineReportContent={userDeclineReportContent}
      isBiyo={isBiyo}
      linkToHomeHandler={linkToHome}
      linkToJobEntryIndexHandler={linkToJobEntryIndex}
      isDeclineDetailsNotEmpty={isDeclineDetailsNotEmpty}
      showDeclineDetailsReadMoreButton={showDeclineDetailsReadMoreButton}
    />
  );
};
